import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../../../components/mui/Styles/index'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import { Box, Card, CardContent, Typography } from '../../../../components/mui/Core/index'
import { ConfirmButton } from '../../../../components/ConfirmButton/confirm-button'
import { resetPasswordConstants } from '../../../../constants/reset-password-constants'
import { routePaths } from '../../../../constants/routes'

function SetNewPasswordSuccess() {
  const theme = useTheme()
  const navigate = useNavigate()

  const navigateToLogin = () => navigate(routePaths.LOGIN)

  const newPasswordSuccessBoxStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }
  const successMessageStyle = { textAlign: 'center' }
  const confirmButtonStyle = { width: '220px' }

  return (
    <Box sx={theme.soloContainer}>
      <Card className='soloCard'>
        <CardContent>
          <Box sx={newPasswordSuccessBoxStyle}>
            <FormHeading formHeader='Password Successfully Reset' />
            <Typography variant='body1' gutterBottom sx={successMessageStyle}>
              {resetPasswordConstants.PASSWORD_RESET_SUCCESS_MESSAGE}
            </Typography>
          </Box>
        </CardContent>
        <Box display='flex' justifyContent='center'>
          <Box sx={confirmButtonStyle}>
            <ConfirmButton
              text={resetPasswordConstants.RETURN_TO_LOGIN}
              onClick={navigateToLogin}
            />
          </Box>
        </Box>
      </Card>
    </Box>
  )
}

export default SetNewPasswordSuccess
